import React from 'react'
import { Descriptions, Typography } from 'antd'

export const renderValidationMetric = value =>
  value == null || (typeof value === 'string' && value.trim() === 'N/A') ? (
    <Typography.Text type="secondary">-</Typography.Text>
  ) : (
    value
  )

export const renderValidationMetricItem = (label, value) => (
  <Descriptions.Item label={label}>
    {renderValidationMetric(value)}
  </Descriptions.Item>
)
